export default __webpack_public_path__ + "static/media/logo-footer.11aca7c8.svg";